import dayjs, {Dayjs} from 'dayjs';

import {QueryMapType} from '../../../../util/type';

import {LocalPackFilterEnum, LocalPackFilterType, LocalPackFilterUrlQueryNameEnum} from './local-pack-filter-type';

// dayjs parses a YYYY-MM-DD string as local midnight, unlike new Date, which treats it as UTC midnight
function getDateFromUrlValue(value: string | void): Dayjs | null {
    if (!value) {
        return null;
    }

    const date: Dayjs = dayjs(value);

    return date.isValid() ? date : null;
}

export function getInitialLocalPackFilter(urlQueries: QueryMapType): LocalPackFilterType {
    const dateFrom: Dayjs | null = getDateFromUrlValue(urlQueries[LocalPackFilterUrlQueryNameEnum.startDate]);
    const dateTo: Dayjs | null = getDateFromUrlValue(urlQueries[LocalPackFilterUrlQueryNameEnum.endDate]);

    const searchQueriesRaw = urlQueries[LocalPackFilterUrlQueryNameEnum.searchQueries];
    const searchQueries: Array<number> =
        typeof searchQueriesRaw === 'string' ? searchQueriesRaw.split(',').map(Number) : [];

    return {
        [LocalPackFilterEnum.timeRange]: [dateFrom, dateTo],
        [LocalPackFilterEnum.searchQueries]: searchQueries,
    };
}
